// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"227":"05b98631","360":"6d287977","430":"5d17dc57","938":"0ed19de8","960":"cab922b0","963":"ac66c409"}[chunkId] + ".css";
};